export default {
  default: () => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m),
  "error-layout": () => import("/opt/build/repo/layouts/error-layout.vue").then(m => m.default || m)
}